// extracted by mini-css-extract-plugin
export var compactFilters = "_dj-4";
export var detailImage = "_dj-1";
export var dropdownContainer = "_dj-2";
export var imageContainer = "_dj-0";
export var selectedCard = "_dj-3";